import script from "./BssMovementNaviationIcons.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMovementNaviationIcons.vue?vue&type=script&lang=ts&setup=true"

import "./BssMovementNaviationIcons.vue?vue&type=style&index=0&id=e87829b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e87829b4"]])

export default __exports__